var _rect, _circle, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXBoxCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 199,
    viewBox: "0 0 358 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 358,
    height: 199,
    rx: 8,
    fill: "#6AC229"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.852,
    cx: 117,
    cy: 104.5,
    r: 25.375,
    fill: "url(#paint0_radial_3061_17558)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.237 123.592C100.202 123.566 100.167 123.534 100.131 123.495C99.4743 122.898 98.4044 121.955 97.2864 120.531C96.3208 118.436 96.8681 114.918 99.2443 109.951C102.597 102.943 107.961 95.8273 110.16 93.3033C109.535 92.6052 107.596 90.6934 104.85 88.6312C102.103 86.569 100.103 86.3578 99.4052 86.4831C100.049 85.7849 101.551 84.4692 102.811 83.5831C106.717 81.6498 113.933 84.9167 117.027 86.7784V99.5865C109.141 105.655 101.846 115.026 100.371 118.678C99.2449 121.465 99.69 123.011 100.131 123.495C100.168 123.528 100.203 123.561 100.237 123.592Z",
    fill: "url(#paint1_linear_3061_17558)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.237 123.591C100.202 123.566 100.167 123.534 100.131 123.495C99.4742 122.897 98.4044 121.955 97.2864 120.53C96.3208 118.436 96.8681 114.918 99.2443 109.951C103.137 101.814 110.16 93.3028 110.16 93.3028C110.16 93.3028 111.415 96.417 114.261 101.814C106.93 108.312 101.846 115.026 100.371 118.677C99.2449 121.465 99.69 123.01 100.131 123.495C100.168 123.528 100.203 123.56 100.237 123.591Z",
    fill: "url(#paint2_linear_3061_17558)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.817 123.592C133.852 123.566 133.887 123.534 133.923 123.495C134.579 122.898 135.649 121.955 136.767 120.531C137.733 118.436 137.186 114.918 134.809 109.951C131.457 102.943 126.093 95.8273 123.893 93.3033C124.519 92.6052 126.457 90.6934 129.204 88.6312C131.95 86.569 133.951 86.3578 134.648 86.4831C134.005 85.7849 132.503 84.4692 131.242 83.5831C127.337 81.6498 120.12 84.9167 117.027 86.7784V99.5865C124.913 105.655 132.208 115.026 133.683 118.678C134.809 121.465 134.364 123.011 133.923 123.495C133.886 123.528 133.851 123.561 133.817 123.592Z",
    fill: "url(#paint3_linear_3061_17558)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.817 123.591C133.852 123.566 133.887 123.534 133.923 123.495C134.579 122.897 135.649 121.955 136.767 120.53C137.733 118.436 137.186 114.918 134.809 109.951C130.917 101.814 123.893 93.3028 123.893 93.3028C123.893 93.3028 122.639 96.417 119.793 101.814C127.123 108.312 132.208 115.026 133.683 118.677C134.809 121.465 134.364 123.01 133.923 123.495C133.886 123.528 133.851 123.56 133.817 123.591Z",
    fill: "url(#paint4_linear_3061_17558)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M159.26 117.5L168.36 104.604L159.26 91.708H164.876L171.74 101.952H171.948L178.864 91.708H184.428L175.328 104.604L184.428 117.5H178.864L171.948 107.204H171.74L164.876 117.5H159.26ZM201.959 118.124C200.538 118.124 199.203 117.916 197.955 117.5C196.707 117.084 195.581 116.477 194.575 115.68C193.605 114.883 192.738 113.877 191.975 112.664H191.767L191.403 117.5H187.035V81.1H192.235V95.66C193.067 94.4813 194.246 93.424 195.771 92.488C197.297 91.552 199.203 91.084 201.491 91.084C204.161 91.084 206.431 91.6733 208.303 92.852C210.175 94.0307 211.597 95.6427 212.567 97.688C213.573 99.7333 214.075 102.039 214.075 104.604C214.075 107.169 213.573 109.475 212.567 111.52C211.597 113.565 210.193 115.177 208.355 116.356C206.553 117.535 204.421 118.124 201.959 118.124ZM200.555 113.704C202.254 113.704 203.71 113.323 204.923 112.56C206.171 111.797 207.125 110.74 207.783 109.388C208.477 108.001 208.823 106.407 208.823 104.604C208.823 102.767 208.477 101.172 207.783 99.82C207.125 98.468 206.171 97.4107 204.923 96.648C203.71 95.8853 202.254 95.504 200.555 95.504C198.891 95.504 197.435 95.8853 196.187 96.648C194.939 97.4107 193.969 98.468 193.275 99.82C192.617 101.172 192.287 102.767 192.287 104.604C192.287 106.407 192.617 108.001 193.275 109.388C193.969 110.74 194.939 111.797 196.187 112.56C197.435 113.323 198.891 113.704 200.555 113.704ZM229.615 118.124C227.189 118.124 224.987 117.569 223.011 116.46C221.07 115.316 219.527 113.739 218.383 111.728C217.239 109.683 216.667 107.308 216.667 104.604C216.667 101.9 217.239 99.5427 218.383 97.532C219.562 95.4867 221.122 93.9093 223.063 92.8C225.039 91.656 227.258 91.084 229.719 91.084C232.181 91.084 234.382 91.656 236.323 92.8C238.299 93.9093 239.842 95.4867 240.951 97.532C242.095 99.5427 242.667 101.9 242.667 104.604C242.667 107.308 242.095 109.683 240.951 111.728C239.807 113.739 238.247 115.316 236.271 116.46C234.295 117.569 232.077 118.124 229.615 118.124ZM229.615 113.964C231.002 113.964 232.267 113.617 233.411 112.924C234.59 112.231 235.543 111.208 236.271 109.856C236.999 108.469 237.363 106.719 237.363 104.604C237.363 102.489 236.999 100.739 236.271 99.352C235.578 97.9653 234.642 96.9427 233.463 96.284C232.319 95.5907 231.071 95.244 229.719 95.244C228.367 95.244 227.102 95.5907 225.923 96.284C224.745 96.9427 223.791 97.9653 223.063 99.352C222.335 100.739 221.971 102.489 221.971 104.604C221.971 106.719 222.335 108.469 223.063 109.856C223.791 111.208 224.727 112.231 225.871 112.924C227.05 113.617 228.298 113.964 229.615 113.964ZM243.912 117.5L253.012 104.604L243.912 91.708H249.528L256.392 101.952H256.6L263.516 91.708H269.08L259.98 104.604L269.08 117.5H263.516L256.6 107.204H256.392L249.528 117.5H243.912Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3061_17558",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117 101.781) rotate(90.0548) scale(28.0938)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499976,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828794,
    stopColor: "#C0BEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#879288"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3061_17558",
    x1: 111.549,
    y1: 84.0657,
    x2: 111.978,
    y2: 98.6731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CC329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3061_17558",
    x1: 106.393,
    y1: 98.4584,
    x2: 111.334,
    y2: 105.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48BF21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3061_17558",
    x1: 122.505,
    y1: 84.0657,
    x2: 122.075,
    y2: 98.6731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CC329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3061_17558",
    x1: 127.66,
    y1: 98.4584,
    x2: 122.72,
    y2: 105.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48BF21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXBoxCard);
export default __webpack_public_path__ + "static/media/XBoxCard.e86e58a574853651f491d92e72e2587c.svg";
export { ForwardRef as ReactComponent };